import { render } from "./HandbookCategoryForm.vue?vue&type=template&id=55b6eb59&scoped=true"
import script from "./HandbookCategoryForm.vue?vue&type=script&lang=js"
export * from "./HandbookCategoryForm.vue?vue&type=script&lang=js"

import "./HandbookCategoryForm.vue?vue&type=style&index=0&id=55b6eb59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b6eb59"]])

export default __exports__